import { render } from "./UpperNav.vue?vue&type=template&id=66d1f668&scoped=true"
import script from "./UpperNav.vue?vue&type=script&lang=js"
export * from "./UpperNav.vue?vue&type=script&lang=js"

import "./UpperNav.vue?vue&type=style&index=0&id=66d1f668&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d1f668"]])

export default __exports__